const makeFileUrl = (media) => {
  const endpoint =
    "https://sportspaddock-filestore-blr.blr1.digitaloceanspaces.com/public/";

  return endpoint + media.filename;
};

export default makeFileUrl;
